/* eslint-disable prettier/prettier */
export const countries = [
  { value: 'Polska', label: 'Polska', isDefault: true },
  { value: 'Bośnia i Hercegowina', label: 'Bośnia i Hercegowina', isDefault: false }
];
